/**
 * SectionLabel — uppercase label used as heading for form sections.
 * Paired with 24px gap sections for a consistent dashboard layout.
 */

import type { CSSProperties, ReactNode } from "react";

interface SectionLabelProps {
  children: ReactNode;
  style?: CSSProperties;
}

export function SectionLabel({ children, style }: SectionLabelProps) {
  return (
    <span
      style={{
        fontSize: 13,
        fontWeight: 700,
        letterSpacing: 0.6,
        textTransform: "uppercase",
        color: "#1f2937",
        display: "block",
        marginBottom: 12,
        ...style,
      }}
    >
      {children}
    </span>
  );
}
